import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { CloudRain, ArrowRight } from "lucide-react";

const CACHE = "oc_seasonal_banner_v1";
const cached = () => { try { return JSON.parse(localStorage.getItem(CACHE)); } catch { return null; } };

// Space is reserved until the banner config loads so the hero below doesn't jump (CLS).
export const SeasonalBanner = () => {
  const [banner, setBanner] = useState(cached);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/public/seasonal-banner`)
      .then((r) => {
        const b = r.data?.active ? r.data : null;
        setBanner(b);
        try {
          if (b) { localStorage.setItem(CACHE, JSON.stringify(b)); localStorage.removeItem(CACHE + "_off"); }
          else { localStorage.removeItem(CACHE); localStorage.setItem(CACHE + "_off", "1"); }
        } catch { /* private mode */ }
      })
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  if (!banner && !loaded && localStorage.getItem(CACHE + "_off") !== "1") return <div className="bg-sky-950 min-h-[136px] sm:min-h-[56px]" aria-hidden="true" data-testid="seasonal-banner-placeholder" />;
  if (!banner) return null;
  return (
    <div className="bg-sky-950 text-white" data-testid="seasonal-banner">
      <div className="max-w-6xl mx-auto px-4 py-3 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-sm text-center">
        <span className="flex items-center gap-2">
          <CloudRain className="w-5 h-5 text-sky-300 shrink-0" />
          <span data-testid="seasonal-banner-message">{banner.message}</span>
        </span>
        <Link
          to={banner.cta_link}
          className="inline-flex items-center gap-1 rounded-full bg-orange-700 px-4 py-1.5 font-semibold text-white transition-colors hover:bg-orange-800"
          data-testid="seasonal-banner-cta"
        >
          {banner.cta_label} <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
};
